import { GridRequest } from "projects/app-core/src/models/gridRequest";
import { GridResponse } from "projects/app-core/src/models/gridResponse";

export interface ExpertClientsGridRequest
  extends GridRequest<
    ExpertClientsSort,
    ExpertClientsFilter,
    ExpertClientsSearch,
    ExpertClientsDateFilter
  > {
  expertId?: string;
  tab?: ExpertClientsTab;
}

export enum ExpertClientsSort {
  NAME = "NAME",
  EMAIL = "EMAIL",
  TOTAL_PLANS = "TOTAL_PLANS",
  TOTAL_PACKS = "TOTAL_PACKS",
  ACTIVE_PLANS = "ACTIVE_PLANS",
  ACTIVE_PACKS = "ACTIVE_PACKS",
  COMPLETED_PLANS = "COMPLETED_PLANS",
  COMPLETED_PACKS = "COMPLETED_PACKS",
}

export enum ExpertClientsFilter {
  PARTNER = "PARTNER",
  TEST_USER = "TEST_USER",
}

export enum ExpertClientsSearch {
  NAME = "NAME",
  EMAIL = "EMAIL",
}

export enum ExpertClientsDateFilter {
  CREATED_AT = "CREATED_AT",
}

export enum ExpertClientsTab {
  ALL = "ALL",
  ACTIVE_CLIENTS = "ACTIVE_CLIENTS",
  INACTIVE_CLIENTS = "INACTIVE_CLIENTS",
}

export interface ExpertClientsGridResponseData {
  userId: string;
  name: string;
  email: string;
  partnerDetails?: {
    partnerId: string;
    partnerName: string;
  };
  totalPlans: number;
  totalPacks: number;
  activePlans: number;
  activePacks: number;
  completedPlans: number;
  completedPacks: number;
  isActive: boolean;
}

export interface ExpertClientsGridFilterData {
  partners: {
    partnerId: string;
    partnerName: string;
  }[];
}

export interface ExpertClientsGridResponse
  extends GridResponse<
    ExpertClientsGridFilterData,
    ExpertClientsGridResponseData
  > {}